import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'pie-chart-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
            viewBox="0 0 53 53"
        >
            <defs>
                <path
                    d="M0,53 C0,82.271 23.729,106 53,106 L53,106 C82.271,106 106,82.271 106,53 L106,53 C106,23.729 82.271,0 53,0 L53,0 C23.729,0 0,23.729 0,53 L0,53 Z"
                    id="tws-path-1"
                />
                <polygon id="tws-path-3" points="0 0 53 0 53 53 0 53" />
            </defs>
            <g
                id="tws-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <mask id="tws-mask-4" fill="white">
                    <use xlink:href="#tws-path-3" />
                </mask>
                <g id="tws-Clip-2" />
                <path
                    d="M49.0614375,21.1171875 C49.1276875,21.392125 49.1873125,21.6670625 49.243625,21.9453125 L29.8158125,21.9453125 L29.8158125,21.1171875 L49.06475,21.1171875 L49.0614375,21.1171875 Z M48.601,19.4609375 C48.687125,19.735875 48.7699375,20.0108125 48.8494375,20.2890625 L29.8125,20.2890625 L29.8125,19.4609375 L48.601,19.4609375 Z M48.0014375,17.8046875 C48.1140625,18.079625 48.21675,18.3545625 48.3194375,18.6328125 L29.8125,18.6328125 L29.8125,17.8046875 L48.0014375,17.8046875 Z M47.2528125,16.1484375 C47.388625,16.4200625 47.521125,16.6983125 47.647,16.9765625 L29.8091875,16.9765625 L29.8091875,16.1484375 L47.2495,16.1484375 L47.2528125,16.1484375 Z M46.341875,14.4921875 C46.5075,14.7638125 46.6665,15.0420625 46.818875,15.3203125 L29.8125,15.3203125 L29.8125,14.4921875 L46.341875,14.4921875 Z M45.2355,12.8359375 C45.43425,13.1075625 45.626375,13.3825 45.8151875,13.6640625 L29.8125,13.6640625 L29.8125,12.8359375 L45.2355,12.8359375 Z M43.903875,11.1796875 C44.142375,11.4513125 44.37425,11.72625 44.5995,12.0078125 L29.8091875,12.0078125 L29.8091875,11.1796875 L43.9005625,11.1796875 L43.903875,11.1796875 Z M42.2906875,9.5234375 C42.4960625,9.71225 42.698125,9.904375 42.8935625,10.103125 C42.976375,10.1859375 43.055875,10.26875 43.135375,10.3515625 L29.8091875,10.3515625 L29.8091875,9.5234375 L42.287375,9.5234375 L42.2906875,9.5234375 Z M40.3065,7.8671875 C40.66425,8.1321875 41.0120625,8.4104375 41.3565625,8.6953125 L29.8125,8.6953125 L29.8125,7.8671875 L40.3065,7.8671875 Z M37.736,6.2109375 C38.206375,6.472625 38.6668125,6.7475625 39.114,7.0390625 L29.8125,7.0390625 L29.8125,6.2109375 L37.736,6.2109375 Z M29.8125,3.7265625 L29.8125,3.544375 C30.1735625,3.597375 30.534625,3.657 30.8956875,3.7265625 L29.8125,3.7265625 Z M34.0094375,4.5546875 C34.5195625,4.73025 35.026375,4.922375 35.52325,5.134375 C35.715375,5.213875 35.9041875,5.3 36.0896875,5.3828125 L29.8091875,5.3828125 L29.8091875,4.5546875 L34.006125,4.5546875 L34.0094375,4.5546875 Z M29.8125,22.7734375 L49.389375,22.7734375 C49.4125625,22.9125625 49.4324375,23.048375 49.4523125,23.1875 L29.8091875,23.1875 L29.8091875,22.7734375 L29.8125,22.7734375 Z M26.5,0 L26.5,26.5 L53,26.5 C53,11.865375 41.134625,0 26.5,0 L26.5,0 Z M23.1875,0.205375 L23.1875,29.8125 L52.794625,29.8125 C51.164875,42.883625 40.015,53 26.5,53 C11.865375,53 0,41.134625 0,26.5 C0,12.985 10.116375,1.835125 23.1875,0.205375 L23.1875,0.205375 Z"
                    id="tws-Fill-1"
                    fill="#3D1C70"
                    mask="url(#tws-mask-4)"
                />
            </g>
        </svg>
    `,
    standalone: false
})
export class PieChartIconComponent {
    @Input()
    iconSize: IconSize;
}
